import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import PopupPillar from "./PopupPillar";
import { useMapEvents } from "react-leaflet";
import { setPopup } from "../../store/reducers/helpersReducer";
import PopupTransformer from "./PopupTransformer";
import PopupFider from "./PopupFider";




const Popup = () => {
  // const dispatch = useDispatch()
  const [popup, setPopup] = useState(null)
  const [popupKey, setPopupKey] = useState(0)
  
  // Подписка на события изменения карты
  useMapEvents({
    popupclose: () => {
      setPopup(null)
    },
    openPopup: (props) => {
      console.log(props)
      // Увеличиваем ключ для принудительного обновления
      setPopupKey(prev => prev + 1)
      setPopup(props)
    }
  });

  // const { popup } = useSelector(
  //     (state) => state.helper
  // );
  console.log(popup)
  if (!popup) return null
  if (popup.class === 'pillar' || popup.class === 'pillars') return <PopupPillar key={`pillar_${popupKey}`} mark={popup.mark} />
  if (popup.class === 'transformer') return <PopupTransformer key={`transformer_${popupKey}`} mark={popup.mark} />
  if (popup.class === 'fider' || popup.class === 'fiders') return <PopupFider key={`fider_${popupKey}`} mark={popup.mark} latlng={popup.latlng} />
  
  // Добавляем fallback return
  return null
}




export default Popup